import * as React from "react";
import {cx}       from "emotion";

import "./gallery-tabs.scss";

import {ComponentLink,
        Link,
        makeChain}     from "@Common/react/cst2";
import {UseState}      from "@Common/react/use-state";
import {Types}         from "@Common/types";

import {IsMobile} from "../utils/is-mobile";


export const GalleryTabs = ({
    tabs,
    activeTabTitle,
    onChangeTab,
    maxTabsOnMobile  = 2,
}:{
    tabs             : Types.Common.UiComponents.PhotoDashboard.Models.GalleryTab[],
    activeTabTitle   : string,
    onChangeTab      : Types.Common.UiComponents.PhotoDashboard.Functions.OnChangeTab,
    maxTabsOnMobile ?: number
}) => (

    makeChain<JSX.Element>()

    // set state vars
    .then("state", (_, next:ComponentLink<typeof UseState<{
        tabIndex  : number,
    }>>) => UseState({
        defaultValue: {
            tabIndex: 0,
        },
        next,
    }))

    // check for mobile
    .then("isMobile", (_, next:Link<JSX.Element, boolean>) => IsMobile({next}))

    // limit tabs to display only two if for mobile
    .then("tabsFiltered", ({state, isMobile}, next:Link<JSX.Element, Types.Common.UiComponents.PhotoDashboard.Models.GalleryTab[]>) => {
        if (!isMobile) return next(tabs);

        return next(tabs.slice(state.value.tabIndex, state.value.tabIndex + maxTabsOnMobile));

    })

    // find disabled status for mobile navigation tabs
    .then("previousDisabled", ({state}, next:Link<JSX.Element, boolean>) => next(state.value.tabIndex === 0))
    .then("nextDisabled", ({state}, next:Link<JSX.Element, boolean>) => next(state.value.tabIndex >= tabs.length - maxTabsOnMobile))

    // render the tabs and contents
    .then(({state, tabsFiltered, isMobile, previousDisabled, nextDisabled}) => (
        <ul className="gallery-tabs-p8a tabs">
        {isMobile && (
            <li className={cx("nav previous", previousDisabled && "disabled")}
                key="prev"
                xd-qa-type="tab" xd-qa-name="previous"
                onClick={() => {
                    if (previousDisabled) return;
                    state.onChange({...state.value, tabIndex: state.value.tabIndex - 1});
                }}
            ><i className="fa fa-chevron-left"></i></li>
        )}
        {tabsFiltered.map((tab, index) => (
            <li className={cx({active: activeTabTitle === tab.title})}
                key={tab.title}
                xd-qa-type="tab" xd-qa-name={tab.title.toLowerCase()}
                onClick={() => onChangeTab(tab.title)}
            >
                {tab.isNew && <span className="new">New</span>}
                {tab.title}
            </li>
        ))}
        {isMobile && (
            <li className={cx("nav next", nextDisabled && "disabled")}
                key="next"
                xd-qa-type="tab" xd-qa-name="next"
                onClick={() => {
                    if (nextDisabled) return;
                    state.onChange({...state.value, tabIndex: state.value.tabIndex + 1});
                }}
            ><i className="fa fa-chevron-right"></i></li>
        )}
        </ul>
    ))

    .run()

);
